<div class="login-screen">
    <div class="row m-0">
        <div class="col-lg-7 p-0">
            <div class="contentLogin">
                <div class="row g-0">
                    <div class="logo-header">
                        <!-- <h5 class="m-0"><a href="faq-page" class="fw-medium">Help</a></h5> -->
                        <div class="col-lg-12 px-4 d-flex">
                            <div class="col-lg-7 p-0 d-flex">
                                <img src="assets/images/logo.svg" alt="" class="img-fluid" srcset=""
                                    (click)="refreshPage()" style="cursor: pointer;">
                            </div>
                            <div class="col-lg-5 p-0 d-flex justify-content-end gap-2 mt-3">
                                <h5 class="m-0">{{ 'DONT_HAVE_ACCOUNT'| translate}} &nbsp;<a [href]="isPartnerFlow ? 'signup/firm-agent?userType=5' : 'signup'" class="fw-medium">{{ 'SIGN_UP' | translate}}!</a></h5>
                                <b> - </b>
                                <h5 class="m-0"><a href="faq-page" class="fw-medium">{{ 'HELP' | translate}}</a></h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="loginbox">
                    <h2 class="text-center mb-4">{{ 'LOGIN' | translate}}</h2>
                    <form class="login-form" [formGroup]="loginForm" (ngSubmit)="form.form.valid" #form="ngForm">
                        <div class="mb-3">
                            <mat-label>{{ 'EMAIL' | translate }}</mat-label>
                            <input matInput class="w-100 form-control" [placeholder]="'ENTER_EMAIL' | translate"
                                formControlName="Email">
                            <mat-error class="text-danger"
                                *ngIf="(form.submitted || loginForm.get('Email')?.touched) && loginForm.controls['Email'].errors?.['required']">
                                {{'EMAIL_REQUIRED' | translate}}
                            </mat-error> <mat-error class="text-danger"
                                *ngIf="(form.submitted || loginForm.get('Email')?.touched) && loginForm.controls['Email'].errors?.['email']">
                                {{'EMAIL_INVALID_MSG' | translate}}
                            </mat-error>
                        </div>
                        <div class="mb-3">
                            <mat-label>{{ 'PASSWORD' | translate}}</mat-label>
                            <div class="position-relative">
                                <input matInput class="w-100 form-control" [placeholder]="'PASSWORD_PLACEHOLDER' | translate"
                                    formControlName="password" type="{{passwordinputType}}"
                                    (keyup)="noSpaceAllowed($event)">
                                <div (click)="changeInputType(passwordinputType,'password')">
                                    <mat-icon *ngIf="passwordinputType == 'password'" aria-hidden="false"
                                        aria-label="Visibility Off" fontIcon="visibility_off"></mat-icon>
                                    <mat-icon *ngIf="passwordinputType == 'text'" aria-hidden="false"
                                        aria-label="Visibility On" fontIcon="visibility_on"></mat-icon>
                                </div>
                                <!-- <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon=" visibility_off"></mat-icon> -->
                                <mat-error class="text-danger"
                                    *ngIf="(form.submitted || loginForm.get('password')?.touched) && loginForm.controls['password'].errors?.['required']">
                                    {{'PASSWORD_REQUIRED_MSG' | translate}}
                                </mat-error>
                                <!-- <mat-error class="text-danger"
                                *ngIf="(form.submitted || loginForm.get('password')?.touched) && loginForm.controls['password'].errors?.['pattern']">
                                Password is invalid
                                </mat-error> -->
                            </div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between w-100 gap-3 flex-wrap">
                            <mat-checkbox class="example-margin" color="primary">{{ 'REMEMBER_ME' | translate }}!</mat-checkbox>
                            <a class="text-decoration-underline text-primary" (click)="forgotPassword()">{{ 'FORGOT_YOUR_PASSWORD' | translate}}</a>
                        </div>
                        <button mat-flat-button color="primary" class="my-3 w-100" (click)="onLogin()">{{ 'LOGIN' | translate}}</button>
                    </form>
                </div>
            </div>

        </div>
        <div class="col-lg-5 p-0">
            <div class="image-height">
                <p>&nbsp;</p>
            </div>

        </div>
    </div>
</div>